// extracted by mini-css-extract-plugin
module.exports = {"container":"LeftMenu-AccountSettings_container_1oL-x","buttons":"LeftMenu-AccountSettings_buttons_1lj2S","mbL":"LeftMenu-AccountSettings_mbL_PYXj_"};